import { render, staticRenderFns } from "./FaqDetail.vue?vue&type=template&id=1095c87e&scoped=true"
import script from "./FaqDetail.vue?vue&type=script&lang=js"
export * from "./FaqDetail.vue?vue&type=script&lang=js"
import style0 from "./FaqDetail.vue?vue&type=style&index=0&id=1095c87e&prod&lang=less&scoped=true"
import style1 from "./FaqDetail.vue?vue&type=style&index=1&id=1095c87e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1095c87e",
  null
  
)

export default component.exports